/* CODES */
export const GET_TAKE_BACKS = "GET_TAKE_BACKS"
export const GET_TAKE_BACKS_SUCCESS = "GET_TAKE_BACKS_SUCCESS"
export const GET_TAKE_BACKS_FAIL = "GET_TAKE_BACKS_FAIL"

export const GET_TAKE_BACK_CARRIERS = "GET_TAKE_BACK_CARRIERS"
export const GET_TAKE_BACK_CARRIERS_SUCCESS = "GET_TAKE_BACK_CARRIERS_SUCCESS"
export const GET_TAKE_BACK_CARRIERS_FAIL = "GET_TAKE_BACK_CARRIERS_FAIL"
export const CLEAR_TAKE_BACK_CARRIERS = "CLEAR_TAKE_BACK_CARRIERS"